// extracted by mini-css-extract-plugin
export default {"pageWrap":"cc-z","fullWidth":"dc-z","heading":"ec-z","fullBleed":"fc-z","hidden":"gc-z"};